import { UseFormReturn } from 'react-hook-form';
import { RegisterFormData } from '../schemas/registerFormSchema';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useTranslation } from 'react-i18next';

interface PersonalInfoFieldsProps {
  form: UseFormReturn<RegisterFormData>;
}

export function PersonalInfoFields({ form }: PersonalInfoFieldsProps) {
  const { t } = useTranslation();
  return (
    <div className='grid grid-cols-2 gap-4'>
      <FormField
        control={form.control}
        name='firstName'
        render={({ field }) => (
          <FormItem className='space-y-2'>
            <FormLabel>{t('registerForm.firstName')}</FormLabel>
            <FormControl>
              <Input
                placeholder={t('registerForm.firstNamePlaceholder')}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name='lastName'
        render={({ field }) => (
          <FormItem className='space-y-2'>
            <FormLabel>{t('registerForm.lastName')}</FormLabel>
            <FormControl>
              <Input
                placeholder={t('registerForm.lastNamePlaceholder')}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
